import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase/config';

interface WhatsAppResponse {
  success: boolean;
  message?: string;
  error?: string;
}

// namat#130: this used to read settings/evolutionApi (API key included) from
// the browser and call Evolution directly. The key now lives only in the
// server's Secret Manager; the `sendWhatsAppText` callable sends on our
// behalf and returns the same { success, message | error } shape, so every
// caller below is unchanged. Staff-only (any active non-customer role).
type SendWhatsAppText = (
  data: { phone: string; message: string }
) => Promise<{ data: WhatsAppResponse }>;

export async function sendWhatsAppMessage(
  phoneNumber: string,
  message: string
): Promise<WhatsAppResponse> {
  try {
    const call = httpsCallable(functions, 'sendWhatsAppText') as unknown as SendWhatsAppText;
    const { data } = await call({ phone: phoneNumber, message });
    if (data && data.success) {
      return { success: true, message: data.message || 'WhatsApp message sent successfully' };
    }
    return { success: false, error: data?.error || 'Unknown error occurred' };
  } catch (error) {
    console.error('Error sending WhatsApp message:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred'
    };
  }
}

export async function sendVideoCallNotification(
  phoneNumber: string, 
  customerName: string, 
  videoCallLink: string,
  language: 'en' | 'ar' = 'en'
): Promise<WhatsAppResponse> {
  // Import translations dynamically
  const { translations } = await import('@/translations');
  
  const template = translations[language]?.videoCall?.notifications?.whatsappMessage || 
    "Hi {{customerName}}, your coach is ready for your video call session. Click this link to join: {{videoCallLink}}";
  
  const message = template
    .replace(/\{\{customerName\}\}/g, customerName)
    .replace(/\{\{videoCallLink\}\}/g, videoCallLink);

  return sendWhatsAppMessage(phoneNumber, message);
}
